import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from "rxjs/Observable";
import {MaintenanceInfo} from "../../models/MaintenanceInfo";

/*
  Generated class for the MaintenanceServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class MaintenanceServiceProvider {

  constructor(public http: Http) {
    console.log('Hello MaintenanceServiceProvider Provider');
  }

  public getMaintenanceInfo(): Observable<MaintenanceInfo[]>{
    return Observable.create((observer) => {
      observer.next(this.getTestData());
      return observer.complete();
    });
  }

  private getTestData(): MaintenanceInfo[]{

    let minfo: MaintenanceInfo[] = [];

    minfo.push({
      number: "А111АА777",
      modelName: "Sprinter Classic",
      mileage: 60030,
      batteryOk: true,
      brakesOk: true,
      mileageOk: true
    });

    minfo.push({
      number: "А222АА777",
      modelName: "Sprinter Classic",
      mileage: 107025,
      batteryOk: true,
      brakesOk: false,
      mileageOk: true
    });

    minfo.push({
      number: "А111АА777",
      modelName: "Sprinter Classic",
      mileage: 250349,
      batteryOk: false,
      brakesOk: false,
      mileageOk: false
    });

    return minfo;
  }
}



// WEBPACK FOOTER //
// ./src/providers/maintenance-service/maintenance-service.ts